var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.stream
    ? _c("div", { staticClass: "sale__counter sale-counter" }, [
        _c("div", { staticClass: "sale-counter__body" }, [
          _vm.stream.status == "prepare"
            ? _c("div", { staticClass: "sale-counter__sale" }, [
                _vm._v(
                  _vm._s(_vm._f("moment")(_vm.stream.date_start, "D MMMM"))
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.stream.status == "process"
            ? _c("div", { staticClass: "sale-counter__sale" }, [
                _vm._v("Уже завтра!"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "sale-counter__title" }, [
            _vm._v("Старт потока"),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]),
        _vm._v(" "),
        _vm._m(1),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sale-counter__text" }, [
      _vm._v(
        "Похудение под контролем нутрициолога и четырехкратного чемпиона мира по пауэрлифтингу всего "
      ),
      _c("strong", [_vm._v("за 166 рубль")]),
      _vm._v(" в день!"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sale-counter__counter" }, [
      _c("div", { staticClass: "sale-counter__counter-title" }, [
        _vm._v("До старта"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sale-counter__counter-block" }, [
        _c("div", { staticClass: "countdown", attrs: { id: "countdown" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }